import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Shield } from 'lucide-react';

const COOKIE_CONSENT_KEY = 'sendpi_cookie_consent';

function getCookie(name) {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return match ? match[2] : null;
}

function setCookie(name, value, days) {
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  document.cookie = `${name}=${value}; expires=${expires}; path=/; SameSite=Lax`;
}

export function CookieConsentBanner() {
  const [show, setShow] = useState(false);
  const location = useLocation();

  // Hide on authenticated routes
  const isAuthRoute = location.pathname.startsWith('/dashboard') || location.pathname.startsWith('/admin') || location.pathname.startsWith('/support');

  useEffect(() => {
    if (isAuthRoute) { setShow(false); return; }
    const consent = getCookie(COOKIE_CONSENT_KEY) || sessionStorage.getItem(COOKIE_CONSENT_KEY);
    if (!consent) setShow(true);
    else setShow(false);
  }, [isAuthRoute]);

  const accept = () => {
    setCookie(COOKIE_CONSENT_KEY, 'accepted', 365);
    sessionStorage.setItem(COOKIE_CONSENT_KEY, 'accepted');
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-0 inset-x-0 z-[90] p-4" data-testid="cookie-banner">
      <div className="max-w-4xl mx-auto bg-[#0E1830] border border-white/10 rounded-2xl p-5 shadow-2xl flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <Shield className="w-5 h-5 text-cyan-400 shrink-0 mt-0.5" />
        <div className="flex-1 min-w-0">
          <p className="text-white/80 text-sm">
            SendPI uses <strong className="text-white">strictly necessary cookies</strong> for authentication only. We do not use tracking, advertising, or analytics cookies.{' '}
            <a href="/privacy" className="text-cyan-400 hover:underline">Read our Privacy Policy</a>.
          </p>
        </div>
        <button
          data-testid="cookie-accept-btn"
          onClick={accept}
          className="bg-gradient-to-r from-cyan-500 to-purple-500 text-white px-6 py-2.5 rounded-full text-sm font-medium hover:opacity-90 transition-opacity whitespace-nowrap shrink-0"
        >
          Got it
        </button>
      </div>
    </div>
  );
}
